
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/languages/[id]",
      function () {
        return require("private-next-pages/languages/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/languages/[id]"])
      });
    }
  